import { render, staticRenderFns } from "./FloatingRepairSelect.vue?vue&type=template&id=ca010028&scoped=true"
import script from "./FloatingRepairSelect.vue?vue&type=script&lang=js"
export * from "./FloatingRepairSelect.vue?vue&type=script&lang=js"
import style0 from "./FloatingRepairSelect.vue?vue&type=style&index=0&id=ca010028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca010028",
  null
  
)

export default component.exports